import axios from '@/axios'
import type ResponseData from '@/types/ResponseData'

export interface PostCategory {
  id?: number
  name: string
  description: string
  posts_count?: number
}

class PostCategoryDataService {
  async getAll(): Promise<ResponseData> {
    // Use the protected route with authentication for now
    return axios.get('/post-categories')
  }

  async getById(id: number): Promise<ResponseData> {
    return axios.get(`/post-categories/${id}`)
  }

  async add(data: Omit<PostCategory, 'id' | 'posts_count'>): Promise<ResponseData> {
    return axios.post('/post-categories', data)
  }

  async update(id: number, data: Omit<PostCategory, 'id' | 'posts_count'>): Promise<ResponseData> {
    return axios.put(`/post-categories/${id}`, data)
  }

  async delete(id: number): Promise<ResponseData> {
    return axios.delete(`/post-categories/${id}`)
  }
}

export default new PostCategoryDataService()
